var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaundrymachineicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5C0 0.671573 0.67157 0 1.5 0H10.5C11.3284 0 12 0.671573 12 1.5V2.4812H0V1.5ZM0 3.7312V12.5C0 13.3284 0.67157 14 1.5 14H10.5C11.3284 14 12 13.3284 12 12.5V3.7312H0ZM2.39249 8.49998C2.39249 8.30052 2.40875 8.10448 2.44008 7.91325C2.44153 7.90337 2.44319 7.89355 2.44503 7.8838C2.47974 7.68243 2.53118 7.48648 2.59795 7.29755C3.09283 5.89742 4.42808 4.89249 5.99998 4.89249C7.99234 4.89249 9.6075 6.50762 9.6075 8.49998C9.6075 10.4923 7.99234 12.1075 5.99998 12.1075C4.00762 12.1075 2.39249 10.4923 2.39249 8.49998ZM3.50227 8.20047C3.54267 7.95962 3.75116 7.7832 3.99538 7.7832H4.34922C5.11387 7.7832 5.56218 7.96974 5.96521 8.13744L6.02536 8.16243C6.40231 8.31853 6.78282 8.46557 7.5362 8.46557H8.03295C8.18002 8.46557 8.31963 8.53032 8.41463 8.64258C8.50963 8.75485 8.55039 8.90325 8.52606 9.0483C8.32389 10.2533 7.27674 11.1715 6.01416 11.1715C4.60744 11.1715 3.46707 10.0311 3.46707 8.62438C3.46707 8.48031 3.47908 8.33866 3.50227 8.20047Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundrymachineicon);
export default __webpack_public_path__ + "static/media/laundrymachineicon.6bfbd1b316970cf6083bb74d27173b44.svg";
export { ForwardRef as ReactComponent };